import React, { PropsWithChildren } from "react";
//#region types
import { AuditSheetNavigationItem } from "models/propTypes/accountingPropTypes";
//#endregion

interface AuditSheetNavigationState {
  items: AuditSheetNavigationItem[];
  index: number;
  current: AuditSheetNavigationItem;
  goTo: (index: number) => void;
}

interface AuditSheetNavigationProviderProps {
  items: AuditSheetNavigationItem[];
  initialIndex: number;
}

const AuditSheetNavigationContext = React.createContext<AuditSheetNavigationState | undefined>(undefined);

export const AuditSheetNavigationProvider: React.FC<PropsWithChildren<AuditSheetNavigationProviderProps>> = (props) => {
  const { items } = props;
  const [index, setIndex] = React.useState(props.initialIndex);

  const goTo = React.useCallback(
    (target: number) => {
      if (target >= 0 && target < items.length) setIndex(target);
    },
    [items]
  );

  return (
    <AuditSheetNavigationContext.Provider value={{ items, index, current: items[index], goTo }}>
      {props.children}
    </AuditSheetNavigationContext.Provider>
  );
};

export function useAuditSheetNavigation() {
  const context = React.useContext(AuditSheetNavigationContext);
  if (!context) throw new Error("useAuditSheetNavigation must be used inside AuditSheetNavigationProvider");
  return context;
}
